<template>
  <div class="">
    <Card class="">
      <template #title> Birimler</template>
      <template #content>
        <div class="mt-1 mb-2 mr-3">
          <Button icon="pi pi-plus " size="small" label="Yeni" @click="_BirimModal()" />
        </div>
        <DataTable v-if="DataTable_render" :columns="columns" :data="BirimListesi" v-on:set-child-data="getDataChild"
          :editbutton="true" />
      </template>
    </Card>

    <Dialog v-model:visible="BirimModal" header="Birim" :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
      :style="{ width: '25vw' }" modal>

      <div class="formgrid grid ">
        <div class="field col md:col-12">
          <label for="BirimAd" class="font-bold block">Birim Ad</label>
          <InputText id="BirimAd" type="text" v-model="BirimAd" :invalid="this.Valid.BirimAd"
            class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-12">
          <label for="BirimAciklama" class="font-bold block">Birim Açıklama</label>
          <Textarea id="UrunTipAciklama" v-model="BirimAciklama" rows="2" cols="30" :invalid="this.Valid.BirimAciklama"
            class="text-base text-color w-full" />
        </div>
      </div>
      <Divider />
      <div class="flex justify-content-end flex-wrap">
        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
          @click="this.handleClick()" autofocus />
        <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
          @click="this._BirimModal()" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import DataTable from "../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../services/GlobalServis";


export default {
  data() {
    return {
      DataTable_render: true,
      BirimListesi: [],
      columns: [
        { field: "Ad", header: "Birim Adı" },
        { field: "Aciklama", header: "Aciklama" },
      ],
      BirimModal: false,
      BirimModelDurum: null,

      BirimAd: "",
      BirimAciklama: "",
      Birim_rowid: null,

      //--------------
      // Validation Elements
      Valid: {
        BirimAd: false,
        BirimAciklama: false,
      }
    };
  },
  methods: {
    getDataChild(getdata_child) {
      this.ResetForm();
      this.BirimModal = !this.BirimModal;
      this.BirimModelDurum = false;
      this.Birim_rowid = getdata_child.data.Birim_rowid;
      let data = {
        Birim_rowid: getdata_child.data.Birim_rowid,
      };
      GlobalServis.GlobalServis("POST", "GetBirimInfo", data).then((res) => {
        if (res.status == 200) {
          this.BirimAd = res.data[0].BirimAd;
          this.BirimAciklama = res.data[0].Aciklama;
          this.BirimKod = res.data[0].Birim_rowid;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _BirimModal() {
      this.BirimModelDurum = true;
      this.BirimModal = !this.BirimModal;
      if (this.BirimModal === true) {
        this.ResetForm();
      }
    },
    handleClick() {
      if (this._FormCheck()) { return; }

      let data = {
        Birim_rowid: this.Birim_rowid,
        BirimAd: this.BirimAd,
        BirimAciklama: this.BirimAciklama,
      };
      if (this.BirimModelDurum) {
        // Yeni Kullanıcı
        GlobalServis.GlobalServis("POST", "SetBirim", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Birim oluşturulmuştur",
              life: 3000,
            });
            this.Refresh();
            this._BirimModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });
      } else {
        // Edit Birim

        GlobalServis.GlobalServis("POST", "UpdateBirim", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Birim düzenlemiştir",
              life: 3000,
            });
            this.Refresh();
            this._BirimModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });
      }
    },
    Refresh() {
      this.DataTable_render = false;
      this.$nextTick(() => {
        this.InitServis();
        this.DataTable_render = true;
      });
    },
    ResetForm() {
      this.BirimAd = "";
      this.BirimAciklama = "";
      this.Birim_rowid = null;
    },
    InitServis() {
      GlobalServis.GlobalServis("GET", "GetBirimTablosu", "").then((res) => {
        if (res.status == 200) {
          this.BirimListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _FormCheck() {
      let Check = false;
      if (this.BirimAd === "") {
        this.Valid.BirimAd = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Birim adı girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.BirimAd = false; Check = false; }

      if (this.BirimAciklama === 0) {
        this.Valid.BirimAciklama = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Açıklama girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.BirimAciklama = false; Check = false; }

      return Check;
    },
  },
  mounted() {
    this.InitServis();
  },
  components: {
    DataTable,
  },
};
</script>